export default function About() {
  return (
    <section className="py-20 px-6 max-w-4xl mx-auto">
      <h2 className="text-4xl font-bold mb-6 text-center md:text-left text-[#2D033B]">
        About Our Foundation
      </h2>

      <p className="text-lg text-[#5A3D73] leading-relaxed mb-6">
        Queen Esther’s Impact Foundation (QEIF) is a faith-driven nonprofit organisation
        committed to restoring lives and transforming communities through faith, love, and service.
        <br />
        We exist because we believe that everyone deserves love and dignity, regardless of background or circumstance. 
        Our heart is to uplift individuals, strengthen families, and support vulnerable communities by responding to real needs with compassion, care, and respect.
      </p>

      <p className="text-lg text-[#5A3D73] leading-relaxed">
        At Queen Esther’s Impact Foundation (QEIF), our work is rooted in faith and guided by love. 
        We serve individuals and communities by responding to real-life challenges with compassion, dignity, and practical support, 
        while reflecting the heart and teachings of Christ in all we do.
        <br />
        We believe that lives are restored not only through words, but through love in action. 
        Through service, outreach, and mentorship, we create safe spaces where people are supported, valued, and able to encounter hope, healing, and transformation.
      </p>
    </section>
  );
}
